// React
import { create } from 'zustand';

// Other
import { getWindowSize } from '../utils/index.js';
import { getWeeklyScheduleOfAthlete } from '../service/httpService/weeklySchedule/index.js';
const useCoachStore = create((set, get) => ({
    openAddUser: false,
    addUserProfileType: null,
    weeklyScheduleOfCheckedAthletes: {},
    loadingWeeklySchedule: false,
    setWeeklyScheduleOfCheckedAthletes: (weeklyScheduleOfCheckedAthletes) => set(({ weeklyScheduleOfCheckedAthletes: weeklyScheduleOfCheckedAthletes })),
    getWeeklyScheduleOfCheckedAthletes: async (year, calendarWeek) => {
        set({ loadingWeeklySchedule: true });
        const { checkedAthletes } = get();
        
        // 1. Requests erstellen und Email "merken"
        // Wir geben hier ein Objekt zurück: { email: ..., data: ... }
        const promises = checkedAthletes.map(athlete => 
            getWeeklyScheduleOfAthlete(athlete.profile.email, year, calendarWeek)
                .then(res => ({ email: athlete.profile.email, data: res.data }))
                .catch(err => ({ email: athlete.profile.email, error: err }))
        );

        try {
            // 2. Warten bis alle fertig sind
            const results = await Promise.all(promises);
            
            // 3. Map aufbauen: { "email@example.com": ScheduleObjekt }
            const scheduleMap = {};
            results.forEach(result => {
                // Nur wenn Daten da sind (und kein Fehler)
                if (result.data) {
                    scheduleMap[result.email] = result.data;
                }
            });
            
            // 4. Store updaten
            set({ weeklyScheduleOfCheckedAthletes: scheduleMap });
        } catch (error) {
            console.error("Error fetching weekly schedules:", error);
        } finally {
            set({ loadingWeeklySchedule: false });
        }
    },
    setOpenAddUser: (value) => set({ openAddUser: value }),
    setAddUserProfileType: (type) => set({ addUserProfileType: type }),

    squads: ['Damen', 'Herren', 'U19', 'U17', 'U15'],

    checkedAthletes: [],
    setCheckedAthletes: (checkedAthletes) => set(({ checkedAthletes: checkedAthletes })),

    windowSize: getWindowSize(),
    setWindowSize: (windowSize) => set(({ windowSize: windowSize })),

    repetitions: 1,
    setRepetitions: (repetitions) => set(({ repetitions: repetitions })),

    selectedTab2: 0,
    setSelectedTab2: (selectedTab2) => set(({ selectedTab2: selectedTab2 })),

    athleteSearch: "",
    setAthleteSearch: (athleteSearch) => set(({ athleteSearch: athleteSearch })),

    coachSearch: "",
    setCoachSearch: (coachSearch) => set(({ coachSearch: coachSearch })),

    parentSearch: "",
    setParentSearch: (parentSearch) => set(({ parentSearch: parentSearch })),

    openEditUser: false,
    setOpenEditUser: (openEditUser) => set(({ openEditUser: openEditUser })),

    openLink: false,
    setOpenLink: (openLink) => set(({ openLink: openLink })),

    linkMessage: "",
    setLinkMessage: (linkMessage) => set(({ linkMessage: linkMessage })),

    selectedViewAthletesTab: JSON.parse(localStorage.getItem('selectedViewAthletesTab')) || "calendarYear",
    setSelectedViewAthletesTab: (selectedViewAthletesTab) => set(({ selectedViewAthletesTab: selectedViewAthletesTab })),

    weeklyScheduleRevisionCounter: 0,
    setWeeklyScheduleRevisionCounter: (weeklyScheduleRevisionCounter) => set(({ weeklyScheduleRevisionCounter: weeklyScheduleRevisionCounter })),

    coaches: [],
    setCoaches: (coaches) => set(({ coaches: coaches })),

    textblockTypes: ['Global', 'Privat'],
    openTextblockView: false,
    setOpenTextblockView: (value) => set({ openTextblockView: value }),

    expandedAccordions: {},
    setExpandedAccordions: (expandedAccordions) => set({ expandedAccordions }),
    toggleAccordion: (panel) => set((state) => ({
        expandedAccordions: {
            ...state.expandedAccordions,
            [panel]: !state.expandedAccordions[panel]
        }
    })),

}));

export default useCoachStore;